import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>
          <strong>The Bug and Frog Foundation</strong>
          <p className="footer-tagline">Small beginnings, mighty leaps.</p>
          <div className="footer-contact">
            Email: <a href="mailto:info@bugandfrog.org">info@bugandfrog.org</a>
          </div>
        </div>

        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/about-us">About</Link>
          <Link to="/who-we-are">Our founders</Link>
        </nav>
      </div>
      <div className="footer-bottom">
        © {year} The Bug and Frog Foundation. All rights reserved.
      </div>
    </footer>
  );
}
